import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {IntegrationAddEdit} from './integrationAddEdit.js';

export var IntegrationProperties = {
	
	transmissionProperties() {
		var propertiesWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Transmission Properties',
			icon: 'vaadin:modal-list',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					propertiesWin.show();

					var propertyTools = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_TRANSMISSION_PROPERTIES:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										addEditProperty();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,
								permissions: ['ADMIN_TRANSMISSION_PROPERTIES:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										addEditProperty(propertyGrid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'error primary',
										permissions: ['ADMIN_TRANSMISSION_PROPERTIES:DELETE'],
										'class': 'spacer-toolbar-item',
										disabled: true,
										children: [
											ElementUtil.makeIcon('vaadin:trash', ' Delete')
										],
										listeners: {
											click: function () {
												deleteProperty(propertyGrid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});

					var propertyGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'transmissionType',
								header: 'Transmission Type',
								width: '7em'
							},
							{
								path: 'key',
								header: 'Key',
								width: '7em'
							},
							{
								path: 'value',
								header: 'Value',
								width: '7em'
							},
							{
								path: 'updateDts',
								header: 'Update Date',
								width: '7em',
								renderer: function (root, column, rowData) {
									root.innerHTML = TimeUtil.formatDateStandard(rowData.item.updateDts);
								}
							},
							{
								path: 'updateUser',
								header: 'Update User',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								propertyGrid.selectedItems = item ? [item] : [];

								if (propertyGrid.selectedItems.length > 0) {
									ElementUtil.query(propertyTools, 'edit').disabled = false;
									ElementUtil.query(propertyTools, 'delete').disabled = false;
								} else {
									ElementUtil.query(propertyTools, 'edit').disabled = true;
									ElementUtil.query(propertyTools, 'delete').disabled = true;
								}
							}
						}
					});

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							propertyTools,
							propertyGrid
						]
					});

					propertiesWin.addToContentElement(layout);

					var actionRefreshProperty = function () {
						var loadMask = propertyGrid.showLoading();
						DataManagementService.getIntegrationService().getTransmissionProperties().then(function (props) {
							loadMask.remove();
							propertyGrid.activeItem = null;
							propertyGrid.items = props.data;
						});
					};
					actionRefreshProperty();

					var addEditProperty = function (prop) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (prop ? 'Edit' : 'Add'),
							icon: 'vaadin:plus',
							width: 500,
							height: 300,
							listeners: {
								ready: function () {
									addEditWin.show();

									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [
													{
														tag: 'vaadin-combo-box',
														label: 'Transmission Type',
														name: 'transmissionType',
														'item-value-path': 'transmissionType',
														'item-label-path': 'transmissionDescription',
														required: true,
														postinit: function (combo) {
															DataManagementService.getIntegrationService().getDefinitions().then(function (data) {
																combo.items = data;
															});
														}
													},
													{
														tag: 'vaadin-text-field',
														label: 'Key',
														name: 'key',
														required: true,
														maxlength: 255
													},
													{
														tag: 'vaadin-text-field',
														label: 'Value',
														name: 'value',
														required: true,
														maxlength: 255
													},
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				return data;
																			},
																			actualCall: function (data) {
																				if (prop) {
																					data.propertyId = prop.propertyId;
																				}
																				return DataManagementService.getIntegrationService().saveTransmissionProperty(data, (prop ? true : false));
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Property', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				if (formPanel.successCallback) {
																					formPanel.successCallback();
																				}
																				actionRefreshProperty();
																				addEditWin.close();
																			}
																		});

																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]

									});
									addEditWin.addToContentElement(formPanel);

									if (prop) {
										formPanel.load(prop);
									}

								}
							}
						});
					};

					var deleteProperty = function (prop) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: 'Are you sure you want to delete property?',
							buttons: [
								{
									text: 'Yes',
									handler: function () {
										var loadMask = propertyGrid.showLoading('Removing Property...');

										DataManagementService.getIntegrationService().deleteTransmissionProperty(prop.propertyId)
												.then(function () {
													loadMask.remove();
													window.DL.MessageUtil.showToast('Success', 'Removed Property', {
														theme: 'success'
													});
													actionRefreshProperty();
												});
									}
								},
								{
									text: 'No'
								}
							]
						});
					};

				}
			}
		});
	},
	
	manageTemplates(transmissionTypes) {
		var templateWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Templates',
			icon: 'vaadin:copy',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					templateWin.show();

					var templateTools = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_INTEGRATIONS:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										addEditTemplate();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,
								permissions: ['ADMIN_INTEGRATIONS:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										addEditTemplate(templateGrid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'error primary',
										permissions: ['ADMIN_INTEGRATIONS:DELETE'],
										'class': 'spacer-toolbar-item',
										disabled: true,
										children: [
											ElementUtil.makeIcon('vaadin:trash', ' Delete')
										],
										listeners: {
											click: function () {
												deleteTemplate(templateGrid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});

					var templateGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'name',
								header: 'Name',
								width: '7em'
							},
							{
								path: 'applicationModuleDescription',
								header: 'Module',
								width: '7em'
							},
							{
								path: 'transmissionType',
								header: 'Transmission Type',
								width: '7em'
							},
							{
								path: 'updateDts',
								header: 'Update Date',
								width: '7em',
								renderer: function (root, column, rowData) {
									root.innerHTML = TimeUtil.formatDateStandard(rowData.item.updateDts);
								}
							},
							{
								path: 'updateUser',
								header: 'Update User',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								templateGrid.selectedItems = item ? [item] : [];

								if (templateGrid.selectedItems.length > 0) {
									ElementUtil.query(templateTools, 'edit').disabled = false;
									ElementUtil.query(templateTools, 'delete').disabled = false;
								} else {
									ElementUtil.query(templateTools, 'edit').disabled = true;
									ElementUtil.query(templateTools, 'delete').disabled = true;
								}
							}
						}
					});

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							templateTools,
							templateGrid
						]
					});

					templateWin.addToContentElement(layout);

					var actionRefreshTemplates = function () {
						var loadMask = templateGrid.showLoading();
						DataManagementService.getIntegrationService().getIntegrations({
							status: 'T'
						}).then(function (props) {
							loadMask.remove();
							templateGrid.activeItem = null;
							templateGrid.items = props.data;
						});
					};
					actionRefreshTemplates();

					var addEditTemplate = function (template) {
						IntegrationAddEdit.addEditIntegration(template, {
							admin: true,
							transmissionTypes: transmissionTypes,
							templateMode: true,
							findTransmission: function(type) {
								var definition;

								transmissionTypes.forEach(function(item){
									if (item.transmissionType === type) {
										definition = item;
									}
								});

								return definition;
							},
							successCallback: function() {								
								actionRefreshTemplates();
							}
						});
					};

					var deleteTemplate = function (template) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: 'Are you sure you want to delete template?',
							buttons: [
								{
									text: 'Yes',
									handler: function () {
										var loadMask = templateGrid.showLoading('Removing Template...');

										DataManagementService.getIntegrationService().deleteIntegration(template.configId)
												.then(function () {
													loadMask.remove();
													window.DL.MessageUtil.showToast('Success', 'Removed Template', {
														theme: 'success'
													});
													actionRefreshTemplates();
												});
									}
								},
								{
									text: 'No'
								}
							]
						});
					};

				}
			}
		});
	},
	
	xrefProperties(xref) {
		var xrefProps = [];
		var propertiesWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Xref Properties',
			icon: 'vaadin:modal-list',
			width: .50,
			height: .50,
			listeners: {
				ready: function () {
					propertiesWin.show();

					var propertyTools = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',								
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										addEditProperty();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,								
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										addEditProperty(propertyGrid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'error primary',										
										'class': 'spacer-toolbar-item',
										disabled: true,
										children: [
											ElementUtil.makeIcon('vaadin:trash', ' Delete')
										],
										listeners: {
											click: function () {
												deleteProperty(propertyGrid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});

					var propertyGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [							
							{
								path: 'key',
								header: 'Key',
								width: '7em'
							},
							{
								path: 'value',
								header: 'Value',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								propertyGrid.selectedItems = item ? [item] : [];

								if (propertyGrid.selectedItems.length > 0) {
									ElementUtil.query(propertyTools, 'edit').disabled = false;
									ElementUtil.query(propertyTools, 'delete').disabled = false;
								} else {
									ElementUtil.query(propertyTools, 'edit').disabled = true;
									ElementUtil.query(propertyTools, 'delete').disabled = true;
								}
							}
						}
					});

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							propertyTools,
							propertyGrid
						]
					});

					propertiesWin.addToContentElement(layout);

					var actionRefreshProperty = function () {						
						propertyGrid.activeItem = null;
						propertyGrid.items = xrefProps.slice();
					};
					
					var addEditProperty = function (prop) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (prop ? 'Edit' : 'Add'),
							icon: 'vaadin:plus',
							width: 500,
							height: 300,
							listeners: {
								ready: function () {
									addEditWin.show();

									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [													
													{
														tag: 'vaadin-text-field',
														label: 'Key',
														name: 'key',
														required: true,
														maxlength: 255
													},
													{
														tag: 'vaadin-text-field',
														label: 'Value',
														name: 'value',
														required: true,
														maxlength: 255
													},
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {
																		
																		var data = formPanel.getData();

																		if (prop) {
																			prop.key = data.key;
																			prop.value = data.value;
																		} else {
																			xrefProps.push({
																				key: data.key,
																				value: data.value
																			});																			
																		}
																		updateXrefProps();
																		actionRefreshProperty();
																		addEditWin.close();
																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]

									});
									addEditWin.addToContentElement(formPanel);

									if (prop) {
										formPanel.load(prop);
									}

								}
							}
						});
					};

					var deleteProperty = function (prop) {
						var keep = [];
												
						xrefProps.forEach(function(item){
							if (item.key !== prop.key) {
								keep.push(item);
							}
						});
						xrefProps = keep;		
						updateXrefProps();
						
						actionRefreshProperty();						
					};
					
					xref.properties = xref.properties || {};
					for (var key in xref.properties) {
						xrefProps.push({
							key: key,
							value: xref.properties[key]
						});
					}
					actionRefreshProperty();					
					
					var updateXrefProps = function() {						
						xref.properties = {};
						xrefProps.forEach(function(item){
							xref.properties[item.key] = item.value;
						});						
					};

				}
			}
		});
		
	}	
	
};

